import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { selectCardEntities } from './EntitiesSelector';

const getCardSearch = state => state.getIn(['cards', 'cardSearch'], Immutable.Map());

export const selectCardsForSearch = createSelector([getCardSearch, selectCardEntities], (cardSearch, cardEntities) =>
  cardSearch.get('results').map(cardId => cardEntities.get(cardId.toString()))
);

export const selectCardSearchParameters = createSelector([getCardSearch], cardSearch => cardSearch);

export default {
  selectCardsForSearch,
  selectCardSearchParameters
};
